import { colors, createTheme } from "@mui/material";
// import { FormHelperText } from '@material-ui/core';

declare module "@mui/material/styles" {
  interface TypeBackground {
    subtle: string;
    tableRowHover: string;
  }
  interface Palette {
    centreOfGravity: {
      danger: string;
    };
    customerStatus: {
      draft: string;
      active: string;
      inactive: string;
    };
    priceQuoteStatus: {
      draft: string;
      sent: string;
      accepted: string;
    };
    profile: {
      avatarBackground: string;
      avatarText: string;
    };
  }
  interface PaletteOptions {
    centreOfGravity?: {
      danger?: string;
    };
    customerStatus?: {
      draft?: string;
      active?: string;
      inactive?: string;
    };
    priceQuoteStatus?: {
      draft?: string;
      sent?: string;
      accepted?: string;
    };
    profile?: {
      avatarBackground?: string;
      avatarText?: string;
    };
  }
}


export const HEADER_FONT_FAMILY =
  '"Mona-Sans"';
export const BODY_FONT_FAMILY = "Noto Sans Hebrew";

export const headerFontFamily = HEADER_FONT_FAMILY;
export const bodyFontFamily = BODY_FONT_FAMILY;

export const COG_DANGER_COLOR = "#C02D2D";
export const SUCCESS_STATUS_COLOR = "#169641";
export const TABLE_ROW_HOVER_COLOR = "#F8FAFF";
export const CUSTOMER_DRAFT_STATUS_COLOR = "#8A909B";
export const QUOTE_SENT_STATUS_COLOR = "#45C2D9";

const theme = createTheme({
  direction: "ltr",
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            pointerEvents: "auto", // Corrected value
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            pointerEvents: "auto", // Corrected value
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: "#F5F8FF",
      paper: colors.common.white,
      subtle: "#FBFDFF",
      tableRowHover: TABLE_ROW_HOVER_COLOR,
    },
    primary: {
      main: "#5A8DF1",
    },
    secondary: {
      main: "#253858",
    },
    grey: {
      400: "#F4F5F7",
    },
    error: {
      main: "#C5090C",
    },
    success: {
      main: SUCCESS_STATUS_COLOR,
      400: SUCCESS_STATUS_COLOR,
    },
    text: {
      primary: "#79808A",
      secondary: colors.blueGrey[600],
      disabled: "#BDC0C3",
    },

    divider: "#E9ECF2",

    info: {
      main: "#5A8DF1",
      light: "#EFF4FE",
    },
    centreOfGravity: {
      danger: COG_DANGER_COLOR,
    },
    customerStatus: {
      draft: CUSTOMER_DRAFT_STATUS_COLOR,
      active: SUCCESS_STATUS_COLOR,
      inactive: CUSTOMER_DRAFT_STATUS_COLOR,
    },
    priceQuoteStatus: {
      draft: CUSTOMER_DRAFT_STATUS_COLOR,
      sent: QUOTE_SENT_STATUS_COLOR,
      accepted: SUCCESS_STATUS_COLOR,
    },
    profile: {
      avatarBackground: "#FADADD",
      avatarText: "#1E2A44",
    },
  },
  typography: {
    fontFamily: bodyFontFamily,
    allVariants: {
      textTransform: "none",
    },
  },
});

export default theme;
